<script>
import { mapGetters, mapState } from 'vuex'
import BreadCrumbs from '@components/breadcrumbs/breadcrumbs-wrapper.vue'

export default {
  data () {
    return { }
  },
  props: {
    hideRouterView: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  components: {
    BreadCrumbs
  },
  mounted () {
    if (this.user.profile.stripe_id && this.activeSubscription && !this.hasNativeSubscription) {
      this.$store.dispatch('portalSession', { token: this.user.token })
    }
  },
  computed: {
    ...mapState(['user', 'home', 'settings', 'challenges', 'challengePage', 'selectedOrder']),
    ...mapGetters(['primaryColor', 'primaryColorRgb', 'secondaryColorRgb', 'loggedIn', 'activeSubscription', 'hasNativeSubscription', 'activeSubscriptionPlan']),
    deepLinkUrl () {
      return this.user.profile.device_type === 'iOS' ? 'https://apple.co/2Th4vqI' : 'https://play.google.com/store/account/subscriptions'
    }
  },
  methods: {}
}
</script>

<template>
  <div class="sub-container" :style="{ '--BGColor': `rgba(${primaryColorRgb}, ${1})`, '--secondaryColor': `rgba(${secondaryColorRgb}, ${1})`}">
    <BreadCrumbs class="second" v-if="(!hideRouterView && isMobile)" @back="$emit('hide-router-view')" />
    <span class="title">{{ this.$_polyglot.t('profile.subscription.title') }}</span>
    <div class="content-container" v-if="activeSubscription && activeSubscriptionPlan">
      <p>
        {{ this.$_polyglot.t('profile.subscription.portalRedirect') }}
      </p>
    </div>
    <div class="content-container" v-else-if="!activeSubscription && hasNativeSubscription">
      <p class="no-sub-note">You have an active {{user.profile.device_type === 'iOS' ? 'Apple' : 'Google'}} subscription. <br /> <br />
        Manage it here <a :href="deepLinkUrl">Subscription Manager</a>
      </p>
    </div>
    <div v-else class="content-container">
      <p>{{ this.$_polyglot.t('profile.subscription.noSub') }} <router-link class="link" to="/">{{ this.$_polyglot.t('profile.subscription.noSubHere') }}</router-link></p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

::v-deep .modal-dialog {
  max-width: 45rem;
  min-height: 100% !important;
  position: relative;
  .modal-header {
    width: 100%;
    text-align: center;
  }
  .modal-content {
    padding: 1.5rem 2.5rem;
    position: relative;
    height: 100%;
    background: #FFFFFF;
    border-radius: 24px;
    box-shadow: 0 0 24px 0 rgba(0,0,0,0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .first-p {
      text-align: center;
      font-weight: 800;
      font-size: 2.2rem;
      line-height: 2.6rem;
    }
    .second-p {
      width: 100%;
      font-size: 1.2rem;
      font-weight: 600;
      line-height: 1.6rem;
      text-align: center;
      margin-top: 1.5rem;
      margin-bottom: 2.5rem;
    }
    .third-p {
      @extend .second-p;
      font-size: 0.9rem;
      color: red;
      margin-top: unset;
      margin-bottom: 10px;
    }
    .buttons {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .btn-primary {
      white-space: nowrap;
      color: white;
      border: 2px solid var(--BGColor);
      background-color: var(--BGColor);
      height: 2.5rem;
      padding: 0rem 1.4rem;
      border-radius: 2rem;
      font-size: 1rem;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      &.save {
        min-width: 10rem;
        border: 2px solid var(--BGColor);
        background-color: var(--BGColor);
        font-size: 0.85rem;
      }
      &.back {
        border: 2px solid black;
        background-color: white;
        color: black;
        font-size: 0.85rem;
        margin-left: 0.5rem;
        &:hover {
          background-color: black;
          color: white;
        }
      }
    }
    }
  }
}

.sub-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 3rem 4.5%;
  .title {
      width: 100%;
      font-family: $base-font-family;
      font-style: normal;
      font-weight: 800;
      font-size: 23px;
      line-height: 52px;
      letter-spacing: -0.761905px;
    }
  .breadcrumb-wrapper {
    margin-bottom: 0.1rem;
    align-self: flex-start;
    margin-left: -0.5rem;
    &.second {
      position: absolute;
      left: 0.3rem;
      top: 0.5rem;
    }
    ::v-deep span {
      img {
        margin-right: 0.2rem;
      }
      h5 {
        font-size: 1.2rem;
      }
    }
  }
  .content-container {
    width: 100%;
    height: 100%;
    margin: 0 auto;
     margin-left: unset;
     .no-sub-note {
       margin-top: 1.5rem;
       font-family: $base-font-family;
       font-style: normal;
       font-weight: normal;
       font-size: 25px;
       @include calc-font-size(1.2);
       line-height: 24px;
       text-align: center;
       color: #000000;
     }
     .button.couponApply {
       width: 100%;
       height: 45%;
       margin: auto;
       text-align: center;
       position: absolute;
       bottom: 20px;
       right: 10px;
       background-color: var(--BGColor);
       &:disabled {
         background-color: grey;
       }
       span {
         position: relative;
       }
     }

  }
  .buttons-container {
    margin-left: unset;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn-primary {
      color: white;
      border: 2px solid var(--secondaryColor);
      background-color: var(--secondaryColor);
      height: 2.5rem;
      padding: 0rem 1.4rem;
      border-radius: 2rem;
      font-size: 1rem;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;

      &.change {
        border: 2px solid var(--secondaryColor);
        background-color: var(--secondaryColor);
        margin-right: 1rem;
        font-size: 0.9rem;

      }
      &.pause {
        border: 2px solid black;
        background-color: black;
        font-size: 0.9rem;

      }
      &.save {
        border: 2px solid black;
        background-color: black;
        font-size: 0.85rem;

      }
      &.back {
        border: 2px solid black;
        background-color: white;
        color: black;
        font-size: 0.85rem;
        margin-left: 0.5rem;

      }
      &.cancel {
        border: unset;
        background-color:transparent;
        color: black;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 0rem;
        padding-left: 0rem;
        font-weight: 800;
      }

      &:hover {
        background-color: white;
        color: black;
      }
    }
  }
}
</style>
